import { tw } from '@careinfo/tailwind';
import { useMemo } from 'react';
import Button from '../Reusable/Button';
import DataTable from '../Reusable/DataTable';
import APIS from '../../constant/EndPoint';
import NACell from '../Reusable/DataTable/NACell';
import BranchSelect from './BranchSelect';
import { useParams } from 'react-router-dom';

const BranchList = (props: any) => {
  const { receiverLocation, handleAsync, isLoading } = props;
  const { slug } = useParams<{ slug: string }>(); // Assuming slug is passed as a prop
  const partnerName = slug?.replace(/-/g, ' ');
  const defaultColumns = [
    {
      header: 'Our Branch',
      accessorKey: 'sender_branch_name',
      cell: NACell,
    },
    {
      header: `${partnerName} Branch`,
      accessorKey: 'receiver_branch_name',
      cell: ({ row, getValue }) => {
        const selectedValue = getValue();
        return useMemo(
          () => (
            <BranchSelect
              id={row?.original?.id}
              value={selectedValue}
              options={receiverLocation}
              slug={slug}
            />
          ),
          [selectedValue, row?.original?.id, receiverLocation, slug]
        );
      },
    },
  ];

  return (
    <DataTable
      url={APIS.BRANCH}
      queryKey={`branch-${slug}`}
      params={{
        delivery_partner__slug: slug,
      }}
      columns={defaultColumns}
      // addNewPagePath='create'
      tableName='Branch'
      actionMenu={
        <div className={tw`flex w-full justify-end`}>
          <div className={tw`w-24`}>
            <Button
              label={'Sync'}
              type={'button'}
              onClick={() => handleAsync()}
              isLoading={isLoading}
            />
          </div>
        </div>
      }
    />
  );
};
export default BranchList;
